<template>
  <div class="page-home relative w-full h-full overflow-x-hidden overflow-y-auto">
    <!-- 顶部banner -->
    <swiper class="w-full h-1075px relative" :options="swiperOption" ref="mySwiper">
      <!-- <div class="absolute w-full h-40px text-white top-0 left-0 z-20 flex items-center px-1/5"
        style="background: rgba(0, 0, 0, 0.3)">
        <swiper class="flex-1 h-full" :options="announcementSwiperOption">
          <swiper-slide class="announcement text-16px truncate flex items-center justify-center">
            <span>平台目前处于试运营阶段，可能有诸多不完善之处，敬请谅解！如在使用过程中有任何建议或者遇到任何问题，欢迎直接给我们提出
              <a @click="$router.push('/suggestion')">建议</a></span>
          </swiper-slide>
        </swiper>
      </div> -->
      <swiper-slide class="relative">
        <img src="@/assets/images/home/banner2.jpg" class="w-full" />
        <div class="absolute bg-transparent w-250px h-65px z-10 left-1/2"
          style="transform: translateX(-50%); top: 510px; cursor: pointer" @click="join"></div>
      </swiper-slide>
      <swiper-slide class="relative">
        <img src="@/assets/images/home/banner1.jpg" class="w-full" />
        <div class="absolute bg-transparent w-250px h-65px z-10 left-1/2"
          style="transform: translateX(-50%); top: 315px; cursor: pointer" @click="join"></div>
      </swiper-slide>
      <swiper-slide class="relative">
        <img src="@/assets/images/home/banner3.jpg" class="w-full" style="width:100%;  height: 100%; cursor: pointer "  @click="jump('LMSC') "/>
        <div class="absolute bg-transparent w-200px h-65px z-10 left-1/2"
          style="transform: translateX(-50%); top: 315px; cursor: pointer" @click="join"></div>
      </swiper-slide>
      <swiper-slide class="relative">
        <img src="@/assets/images/aipc/banner1aipc.jpg" class="w-full" style="width:100%;  height: 100%; cursor: pointer "  @click="jump('AMDAIPC2025') "/>
        <div class="absolute bg-transparent w-200px h-65px z-10 left-1/2"
          style="transform: translateX(-50%); top: 315px; cursor: pointer" @click="join"></div>
      </swiper-slide>
      <!-- 根据情况引入控件 -->
       <!-- // 底部按钮 -->
      
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- models -->
    <div class="w-full models">
      <div class="relative inner">
        <div class="model-text">
          <div class="text-48px text-black">模型 Models</div>
          <div class="text-20px mt-35px" style="line-height: 22px;">汇聚重点基础模型以及中文特色模型等，让模型的使用更方便。
            视觉模型、NLP模型、语音模型、多模态模型、科学计算模型、时间序列模型、其他等
            面向金融、医疗、工业、交通、政务、科研、营销等主要应用场景
            模型类型：LLM（大语言模型），SAM（分割模型），Diffusion（扩散模型）…
          </div>
          <el-button class="mt-60px" type="primary" @click="go('/models')">了解更多</el-button>
        </div>
        <img src="@/assets/images/home/model-img.png" class="model-pic">
      </div>
    </div>
    <div class="w-full relative bg-white data-set">
      <div class="text-center title">数据集 Datasets</div>
      <div class="text-center text-20px mt-35px">汇聚AI领域开源数据集， 让数据集的获取更容易。</div>
      <div class="text-center text-20px mt-10px mb-90px">文本数据、语音数据、图片数据、多模态数据、科学研究数据等。期待大家一起贡献各类高质量的数据集</div>
      <table class="text-center text-30px pure-table">
        <tr v-for="(item, index) in dataSet">
          <td v-for="(itm, idx) in item.list" @mouseover="overFn(index, idx)" :class="{ 'active-td': itm.active == 1 }">
            <div class="flex items-center justify-center">
              <img :src="itm.active == 1 ? itm.activeIcon : itm.icon" class="icon-img">
              <span class="ml-50px" :class="{ 'pointer': itm.url }" @click="go(itm.url)">{{ itm.title }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- 邀请加入 -->
    <div class="w-full relative">
      <img src="@/assets/images/home/invite_join.png" class="w-full" />
      <!-- 内容 -->
      <div class="absolute w-full text-center left-0 bottom-220px">
        <div class="text-40px font-bold" style="color: #492cba">
          <span class="mx-26px" v-for="(item, index) in ['中立', '开放', '共建', '共创', '合作']" :key="index">
            {{ item }}
          </span>
        </div>
        <div class="text-24px my-40px" style="color: #736d8a">
          欢迎各类科研单位、企事业单位、个人等参与和加入
        </div>
        <el-button class="w-200px" type="primary" @click="join">加入</el-button>
      </div>
    </div>
    <!-- 敬请期待 -->
    <div class="w-full relative">
      <img src="@/assets/images/home/watting.png" class="w-full" />
      <div class="absolute w-full text-center left-0 bottom-150px text-white">
        <div class="text-40px font-bold">
          <span class="mx-20px" v-for="(item, index) in ['更多内容', '敬请期待']" :key="index">
            {{ item }}
          </span>
        </div>
        <div class="text-24px my-50px">
          欢迎大家提意见和需求，共同参与社区建设
        </div>
        <el-button class="w-200px" is-plain @click="go('/suggestion')">建议</el-button>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/layout/footer.vue'
// 注意下边引入的swiper和swiperSlide第一个字母s都是小写的，大写会报错
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  components: { Footer, swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        spaceBetween: 15, // 图片之间的间距
        centeredSlides: true, // 居中还是从图1开始
        slidesPerView: 'auto', // 一屏幕显示几个? 数字或者默认  auto 自动。
        notNextTick: true, // true:加载后允许触发事件 false:加载后不可以触发事件
        // loop: true, // 循环吗
        initialSlide: 0, // 从第几个开始
        autoplay: {
          delay: 5000, // 等5秒下一个
          disableOnInteraction: false // 中间滑动一下，取消自动吗？
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }, // 下按钮
        speed: 800, // 滑动时候动画的速度
        paginationClickable: true, // 下面按钮让点吗
        navigation: {
          prevEl: '.swiper-button-prev', // 左侧按钮
          nextEl: '.swiper-button-next' // 右侧按钮
        },
        effect: 'fade', // 渐入效果
        watchSlidesProgress: true, // 开启这个参数来计算每个slide的progress
        watchSlidesVisibility: true // 先要开启watchSlidesProgress参数，如果开启watchSlidesVisibility，则会在每个slide增加一个指示该slide的progress值得classname
        // autoHeight: true  // 图片高度自适应
      },
      dataSet: [{
        list: [{
          title: '文本数据',
          icon: require('@/assets/images/home/data-set1.png'),
          activeIcon: require('@/assets/images/home/data-set1-hover.png'),
          active: 1
        }, {
          title: '语音数据',
          icon: require('@/assets/images/home/data-set2.png'),
          activeIcon: require('@/assets/images/home/data-set2-hover.png'),
        }]
      }, {
        list: [{
          title: '图片数据',
          icon: require('@/assets/images/home/data-set3.png'),
          activeIcon: require('@/assets/images/home/data-set3-hover.png'),
        }, {
          title: '多模态数据',
          icon: require('@/assets/images/home/data-set4.png'),
          activeIcon: require('@/assets/images/home/data-set4-hover.png'),
        }]
      }, {
        list: [{
          title: '科学研究数据',
          icon: require('@/assets/images/home/data-set5.png'),
          activeIcon: require('@/assets/images/home/data-set5-hover.png'),
        }, {
          title: '其他更多......',
          icon: require('@/assets/images/home/data-set6.png'),
          activeIcon: require('@/assets/images/home/data-set6-hover.png'),
          url: '/datasets'
        }]
      }],
      announcementSwiperOption: {
        direction: 'vertical' // 垂直滑动
        // autoplay: {
        //   delay: 5000, // 等5秒下一个
        //   disableOnInteraction: false // 中间滑动一下，取消自动吗？
        // }
      },
      announcement: [
        {
          content: '这个网站很不错，资源丰富，交互体验很棒！★★★★★',
          username: 'yu724nbsaf87',
          usertype: 0,
          type: 'idea'
        },
        {
          content: '首页banner图可以多几张，方便我们更深入的了解',
          username: '3fdv5efdv',
          usertype: 0,
          type: 'suggestion'
        },
        {
          content: '希望回复功能可以完善一下~',
          username: 'Kobe Bryant',
          usertype: 1,
          type: 'requirement'
        }
      ]
    }
  },
  created() { },
  mounted() { },
  methods: {
    jump(e){
      this.$router.push('/'+e)
    },
    join() {
      if (!this.$store.state.system.userInfo) {
        this.$store.dispatch('system/toLogin', true)
      }
    },
    go(url) {
      this.$router.push(url)
    },
    overFn(index, idx) {
      this.dataSet.forEach(item => {
        item.list.forEach(itm => {
          itm.active = 0
        })
      })
      this.dataSet[index].list[idx].active = 1
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>

.page-home {
  background: #f7f3fc;

  .announcement {
    a {
      font-weight: bold;
      text-decoration: underline;

      &:hover {
        cursor: pointer;
      }
    }
  }
}

.models {
  background-color: #F7F3FC;
  background-image: url('@/assets/images/home/model-bg.png');
  padding: 100px 0 240px 0;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  height: 940px;

  .inner {
    width: 74%;
    margin: 0 auto;
  }
  .model-text{
    position: absolute;
    width: 40%;
    z-index: 10;
  }
  .model-pic{
    width: 74%;
    position: absolute;
    right: 0;
  }
}

.data-set {
  padding: 100px 0 240px 0;
  background-image: url('@/assets/images/home/dataset-bg.png');
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center;

  .title {
    font-size: 48px;
    color: #000;
  }

  .icon-img {
    width: 9%;
  }

  .pointer {
    cursor: pointer;
  }

  .pure-table {
    border: 1px solid #000;
    margin: 0 auto;
    width: 74%;
    background-color: #fff;
  }

  .pure-table td {
    border-left: 1px solid #000;
    border-width: 0 0 0 1px;
    font-size: inherit;
    margin: 0;
    padding: 60px 10px;
    border-bottom: 1px solid #000;
  }

  .active-td {
    background: linear-gradient(to right, #8A4395, #492CBA);
    color: #fff;
  }

  .pure-table>tr:last-child>td {
    border-bottom-width: 0;
  }

  .bg-img {
    width: 80%;
    position: relative;
  }
}
@media only screen and (max-width: 768px) {
  .models{
    height: auto;
    .model-text{
      position: initial;
      width: 100%;
      z-index: 10;
    }
    .model-pic{
      width: 100%;
      position: initial;
      right: 0;
    }
  }
}

</style>
